require("!!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/raw-loader/index.js!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/node_modules/chart.js/dist/Chart.js"))


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/script-loader!/home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/chart.js/dist/Chart.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/Chart.js
// module chunks = 4